<template>
    <div id="EnCycleBadgeCaseList" class="w3 w90-mb">
        <h1 class="h1">
            Products awarded with the recycled marine debris product label
        </h1>
        <ul>
            <li
                v-for="(company, index) in badgeCaseData"
                :key="'cycle-badge-company-' + index"
            >
                <router-link
                    tabindex="0"
                    role="button"
                    :to="{
                        name: 'EnCycleBadgeCaseDetail',
                        params: { companyId: company.company.companyId },
                    }"
                >
                    <img
                        :src="company.company.logoUrl"
                        :alt="company.company.name + ' Logo'"
                    />
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
import getBadgeCaseCompanies from '@/data/getBadgeCaseCompanies'
export default {
    name: 'EnCycleBadgeCaseList',
    setup() {
        const { badgeCaseData } = getBadgeCaseCompanies()
        return { badgeCaseData }
    },
}
</script>
<style lang="scss" scoped>
#EnCycleBadgeCaseList {
    margin-bottom: 80px;
}
ul {
    display: grid;
    @media screen and (min-width: 768px) {
        grid-template: auto / repeat(3, 1fr);
        grid-gap: 20px;
    }
    @media screen and (max-width: 767px) {
        grid-template: auto / repeat(2, 1fr);
        grid-gap: 10px;
    }
}
a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    border-radius: 10px;
    border: 1px solid $grayD;
    transition: 0.3s;
    &:hover,
    &:focus {
        border-color: $gray6;
    }
}
img {
    max-width: 80%;
    max-height: 80%;
}
</style>
